import React from 'react';
import { Link } from 'react-router-dom';
import { History } from 'lucide-react';
import { IITH, SERIF } from '@/pages/landing/iithBrand';

function initial(name) {
  return ((name || '?').trim()[0] || '?').toUpperCase();
}

/** Rich person card for the family tree (tap → care history). */
export default function FamilyPersonCard({
  person, you = false, accent = IITH.navyMid, featured = false,
}) {
  const p = person || {};
  const meta = [
    p.gender,
    p.age != null && p.age !== '' ? `${p.age} yrs` : null,
    p.patient_number || p.mrn,
  ].filter(Boolean).join(' · ');

  return (
    <Link
      to={`/patient/care?patient_id=${p.id}`}
      className={`group relative flex flex-col items-center rounded-2xl border bg-white px-4 py-4 text-center shadow-sm transition hover:-translate-y-0.5 hover:shadow-md ${
        featured ? 'border-[#F15A22]/50 ring-2 ring-[#F15A22]/15' : 'border-[#D5DEE8]'
      }`}
      style={{ minWidth: featured ? 148 : 128, maxWidth: 168 }}
      data-testid={`family-node-${p.id}`}
    >
      {you ? (
        <span
          className="absolute -top-2.5 left-1/2 -translate-x-1/2 rounded-full px-2 py-0.5 text-[9px] font-bold uppercase tracking-wider text-white shadow"
          style={{ background: IITH.saffron }}
        >
          You
        </span>
      ) : (
        <span className="absolute -top-2.5 left-1/2 -translate-x-1/2 rounded-full border border-[#E8EEF5] bg-[#F8FAFC] px-2 py-0.5 text-[9px] font-bold uppercase tracking-wider text-[#5A6B7C]">
          {p.relationship || 'family'}
        </span>
      )}
      <span
        className={`mt-1 flex items-center justify-center rounded-full font-bold text-white shadow-inner ${
          featured ? 'h-16 w-16 text-xl' : 'h-12 w-12 text-base'
        }`}
        style={{
          background: `linear-gradient(145deg, ${accent}, ${you ? '#9a3412' : '#040E1A'})`,
        }}
      >
        {initial(p.name)}
      </span>
      <span
        className="mt-2.5 text-sm font-semibold text-[#071B34] leading-snug line-clamp-2"
        style={{ fontFamily: SERIF }}
      >
        {p.name}
      </span>
      {meta ? <span className="mt-1 text-[10px] text-[#7A8B9C] line-clamp-1">{meta}</span> : null}
      <span
        className="mt-2 inline-flex items-center gap-1 text-[10px] font-semibold opacity-70 group-hover:opacity-100"
        style={{ color: IITH.saffron }}
      >
        <History className="h-3 w-3" /> Care history
      </span>
    </Link>
  );
}
